<div *ngIf="drivenLimits && customerSearchForm">
  <form [formGroup]="customerSearchForm" (ngSubmit)="searchCustomers()">
    <div style="margin-top: 20px" class="grid">
      <div class="col-2 text-right">Customer Name:</div>
      <div class="col-8">
        <input name="customerName" type="text" pInputText formControlName="name" />
      </div>
      <div class="col-2">
        <button type="submit" pButton label="Search" icon="fa fa-search"></button>
      </div>
    </div>
  </form>

  <p-table
    #dt
    selectionMode="single"
    [(selection)]="selectedCustomer"
    [value]="customers"
    [lazy]="false"
    [responsive]="true"
    [paginator]="false"
    rowHover="true"
    resizableColumns="true"
    [styleClass]="'rowStyle'"
    [hidden]="!customersLoaded"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Name</th>
        <th pSortableColumn="addressLine1">Address</th>
        <th pSortableColumn="town">Town</th>
        <th pSortableColumn="postcode">Postcode</th>
        <th>Active</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item" (click)="onCustomerSelected()">
        <td>{{ item.name }}</td>
        <td>{{ item.addressLine1 }}</td>
        <td>{{ item.town }}</td>
        <td>{{ item.postcode }}</td>
        <td style="text-align: center">
          <i class="fa fa-check check-green" *ngIf="item.inactive == null"></i>
          <i class="fa fa-times times-red" *ngIf="item.inactive != null"></i>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-tabView #tabviewMain>
    <p-tabPanel header="Driven">
      <app-full-calendar
        [eventData]="drivenLimits"
        [dayColors]="drivenDayColors"
        [calendarName]="'fc1'"
        (calendarDayClicked)="onDateClicked($event, OrderLimitType.Driven)"
      >
      </app-full-calendar>
    </p-tabPanel>

    <p-tabPanel header="Transported">
      <ng-template pTemplate="content">
        <app-full-calendar
          [eventData]="transportLimits"
          [calendarName]="'fc2'"
          (calendarDayClicked)="onDateClicked($event, OrderLimitType.Driven)"
        >
        </app-full-calendar>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>

<p-dialog
  *ngIf="form"
  header="Order Limits"
  [visible]="editDayLimits"
  [responsive]="true"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '800px' }"
>
  <form [formGroup]="form" (ngSubmit)="saveDayLimit()">
    <div class="grid" style="margin-bottom: 15px">
      <div class="col-6">
        Selected Date: <strong>{{ this.selectedDate }}</strong>
      </div>
      <div class="col-6" *ngIf="selectedCustomer">
        Selected Customer: <strong>{{ this.selectedCustomer?.name }}</strong>
      </div>
    </div>

    <div class="grid">
      <div class="col-4">Global Driven Limit</div>
      <div class="col-8"><input type="number" formControlName="drivenLimit" /></div>

      <div class="col-4">Global Transported Limit</div>
      <div class="col-8"><input type="number" formControlName="transportedLimit" /></div>
    </div>

    <div class="grid" *ngIf="selectedCustomer">
      <div class="col-4">Customer Driven Limit</div>
      <div class="col-8"><input type="number" formControlName="customerDrivenLimit" /></div>

      <div class="col-4">Customer Transported Limit</div>
      <div class="col-8"><input type="number" formControlName="customerTransportedLimit" /></div>
    </div>

    <div class="grid" style="float: right; margin-top: 20px">
      <button
        type="submit"
        class="ui-button-success"
        pButton
        icon="fa fa-check"
        label="Save"
      ></button>

      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="closeDialog()"
      ></button>
    </div>
  </form>
</p-dialog>
